import type { VoucherRuleTrigger } from '@/gql/graphql';
import { oneOf } from '@/hooks/useUrlState';
import { voucherTriggerLabel } from '@/lib/labels';

/** The trigger filter's options, in the order it lists them, with their labels. */
export const VOUCHER_RULE_TRIGGER_LABELS: Record<VoucherRuleTrigger, string> = {
  POINTS_THRESHOLD: voucherTriggerLabel('POINTS_THRESHOLD'),
  FIRST_CARD_LINKED: voucherTriggerLabel('FIRST_CARD_LINKED'),
  BIRTHDAY: voucherTriggerLabel('BIRTHDAY'),
  TICKET_CLAIMED: voucherTriggerLabel('TICKET_CLAIMED'),
};

/** The /voucher-rules query string (see README "List pages, URL state"): `show=active` leaves out inactive rules, `all` (the default) lists them. */
export const voucherRulesUrlSchema = {
  show: oneOf<'all' | 'active', 'all' | 'active'>({ all: true, active: true }, 'all'),
  trigger: oneOf(VOUCHER_RULE_TRIGGER_LABELS, ''),
};

/** The keys that live in the collapsible Filters panel: it opens on mount when `show` is set. */
export const VOUCHER_RULES_ADVANCED_KEYS = ['show'] as const satisfies readonly (keyof typeof voucherRulesUrlSchema)[];
